import React,{useState,useContext} from 'react'
import {Alert,Row,Col} from 'react-bootstrap'
import Loading from '../../components/Loading/index.js'
import LoadingFailed from '../../components/LoadingFailed/index.js'
import Input from '../../components/Input/index.js'
import PrefixContext from '../../context/PrefixContext.js'
import { useParams } from 'react-router';
import {MdError} from 'react-icons/md'
import {HiBadgeCheck} from 'react-icons/hi'
import axios from 'axios'

function Index() {

    const { id,otp } = useParams();
    const [loading, setloading] = useState('LOADED');
    const PrefixContextData = useContext(PrefixContext);
    const defaultValidation = {
        validationStatus: null,
        validationStatusClass: null,
        validationStatusMessage: null,
        password:[],
        cpassword:[]
    }
    const [validation,setValidation] = useState(defaultValidation);
    const [data, setdata] = useState({
        password:"",
        cpassword:""
    })
    const setDefaultValidation = () =>{
        setValidation(defaultValidation);
    }

    const resetPassword = async (e) => {
        e.preventDefault();
        if(loading === 'LOADED')
        {
            setloading('LOADING')
            setDefaultValidation();
            axios.post(PrefixContextData.prefixUrl+'user/reset/'+id+'/'+otp , data)
            .then(response => {
                if(response.status === 200){
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'success',
                        validationStatusMessage: response.data.successMessage,
                        password:null,
                        cpassword:null
                    });
                    setloading('LOADED')
                }
            })
            .catch(error => {
                if(error.response !== undefined && error.response.data !== undefined && error.response.data.errorMessageDetails !== undefined ){
                    let errorDetails = {};
                    error.response.data.errorMessageDetails.forEach((e)=>{
                        errorDetails[e.param] = e.msg;
                    })
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'danger',
                        validationStatusMessage: error.response.data.errorMessage,
                        password:(errorDetails.password !== undefined) ? errorDetails.password : null,
                        cpassword:(errorDetails.cpassword !== undefined) ? errorDetails.cpassword : null,
                    });
                    setloading('LOADED')
                }
                else{
                    setValidation({
                        validationStatus: true,
                        validationStatusClass:'danger',
                        validationStatusMessage: error.message,
                        password:null,
                        cpassword:null,
                    });
                    setloading('LOADED')
                }
            });
        }
    }

    const onChangeHandler = (e) =>{
        const newData = {
            ...data
        }
        newData[e.target.name]=e.target.value;
        setdata(newData);
    }

    return (
        <>
            {loading === 'LOADING' && <Loading  type="withImage" />}
            {loading === 'LOADED' && 
                <div className="new-section page-heading-margin bg-secondary d-flex">
                    <div className="bg-white h-100 px-4 py-5 mx-auto my-auto" style={{maxWidth:'650px'}}>
                        <div className="text-center">
                            <h5 className="text-center pt-2 pb-2">Reset Password</h5>
                            {validation.validationStatus === true && <Alert className="mb-0 d-inline-block" variant={validation.validationStatusClass}>
                                {validation.validationStatusClass === 'success' && <HiBadgeCheck/>}
                                {validation.validationStatusClass === 'danger' && <MdError/>}
                                &nbsp;&nbsp; {validation.validationStatusMessage}
                            </Alert>}
                        </div>
                        <form className="contactForm" onSubmit={(e)=>resetPassword(e)}>
                            <Row  className="px-3" style={{maxWidth:'650px'}}>
                                <Col xs="3" md="3" className="align-self-center">
                                    <label htmlFor="password">New Password</label>
                                </Col>
                                <Col xs="9" md="9">
                                    <Input type="password" name="password"  onChangeHandler={onChangeHandler} validationError={validation.password}/>
                                </Col>
                                <Col xs="3" md="3" className="align-self-center">
                                    <label htmlFor="password">Confirm New Password</label>
                                </Col>
                                <Col xs="9" md="9">
                                    <Input type="password" name="cpassword"  onChangeHandler={onChangeHandler} validationError={validation.cpassword}/>
                                </Col>
                                <Col>
                                    <div className="text-center">
                                        <button className="btn-primary mt-3" type="submit">Submit</button>
                                    </div>
                                </Col>
                            </Row>
                        </form>
                    </div>
                </div>
            }
            {loading === 'FAILED' && 
                <div className="new-section page-heading-margin bg-secondary d-flex flex-column justify-content-center">
                    <LoadingFailed type="withImage" label="Something went wrong. The reset token might be expired. Please resubmit the forgot password form in the login page" />
                </div>
            }
        </>
    )
}

export default Index
